// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  DeploymentInstanceStatus,
} from "./types";

export default {
  deploymentId: __t.u32(),
  get status() {
    return DeploymentInstanceStatus;
  },
  fqdn: __t.option(__t.string()),
  errorMessage: __t.option(__t.string()),
  revisionCreatedAt: __t.option(__t.string()),
  imagePushedAt: __t.option(__t.string()),
};
